import { ModelBase } from "@singularsystems/neo-core";
import AppDataLookup from "../Models/Portfolio/AppDataLookup";
import { AppService, Types } from "../TransactionsTypes";

const currencyStorageKey = "participant.currencyId";

/** Exchange rate service which deals specifically with the portfolio objects. */
export class PortfolioExchangeRateService extends ModelBase {

    constructor(
        private appData: AppDataLookup,
        fetchedCurrencyId: number,
        private pricingApiClient = AppService.get(Types.Transactions.ApiClients.PricingApiClient),
    ) {
        super();
        this._fetchedCurrencyId = fetchedCurrencyId;
        this._currencyId = PortfolioExchangeRateService.getCurrencyIdFromStorage();

        this.makeObservable();
    }

    public exchangeRatesTask = AppService.get(Types.Neo.TaskRunner);

    private _currencyId: number | null = null;

    public get currencyId() {
        return this._currencyId;
    }
    public set currencyId(value: number | null) {
        this._currencyId = value;
        this.onCurrencyChanged(value);
    }

    private _fetchedCurrencyId: number | null = null;

    public get fetchedCurrencyId() {
        return this._fetchedCurrencyId;
    }

    public hasMissingExchangeRates = false;

    public get showMissingExchangeRateWarning() {
        return this.hasMissingExchangeRates && this.currencyId !== null;
    }

    private async onCurrencyChanged(currencyId: number | null) {

        window.localStorage.setItem(currencyStorageKey, currencyId?.toString() ?? "");

        if (currencyId) {

            if (currencyId !== this._fetchedCurrencyId) {
                const result = await this.exchangeRatesTask.waitFor(this.pricingApiClient.getExchangeRates(currencyId));
                this.appData.exchangeRates.set(result.data);
                this._fetchedCurrencyId = this.currencyId;
            }
        }

        this.setInstrumentRates();
    }

    public setInstrumentRates() {
        this.hasMissingExchangeRates = this.appData.setInstrumentRates(this.lastFetchedCurrency, this.currencyId !== null);
    }

    public get lastFetchedCurrency() {
        return this.appData.mainCurrencies.find(c => c.currencyId === this._fetchedCurrencyId)!;
    }

    public static getCurrencyIdFromStorage() {
        const currencyId = window.localStorage.getItem(currencyStorageKey);
        return currencyId ? parseInt(currencyId) : null;
    }
}